export default "/assets/images/twilight-blue-sm.jpg?c01c0e70b0a30fd8d5ab0b1bf5ab428a";